import { SectionConfig } from "../../types";
import { selectStorageFilepath } from "../selectors";
import { buildOwnLabel } from "./helpers";

const config: SectionConfig = {
  section: "storageFilepath",
  titleKey: "confirmRuleUpdates.storageFilepathStep.title",
  selector: selectStorageFilepath,
  properties: {
    override: { label: "storageFilepath.override.label", format: "boolean" },
    filepath: {
      label: "confirmRuleUpdates.filepathChanges.folderStructure",
      format: { resolve: "filepath" },
    },
    copyPolicy: {
      label: buildOwnLabel("filepathCopyPolicy"),
      format: { resolve: "copyPolicy" },
    },
    bodySubfolder: { label: "storageFilepath.enableBodySubfolder.label" },
    emailSubfolder: { label: "storageFilepath.enableEmailSubfolder.label" },
    attachmentsSubfolder: {
      label: "storageFilepath.enableAttachmentsSubfolder.label",
    },
    collaboration: {
      label: "storageFilepath.enableCollaborate.label",
      format: { resolve: "collaboration" },
    },
    // One row per name format field, titled with the same label the form
    // puts above each input.
    nameFormatEmail: {
      label: "ruleAction.advanced.textFields.email",
      format: "variableTokens",
    },
    nameFormatAttachments: {
      label: "ruleAction.advanced.textFields.attachments",
      format: "variableTokens",
    },
    nameFormatPdf: {
      label: "ruleAction.advanced.textFields.pdf",
      format: "variableTokens",
    },
  },
};

export default config;
